import React, {Component} from 'react';
import PropTypes from 'prop-types';
import WhitePortlet from '../utils/WhitePortlet';
import SitesList from './SitesList';
import i18next from 'i18next';
import {connect} from 'react-redux';
import * as sitesApi from './../../api/sites-api';
import ErrorBox from './../utils/ErrorBox';
import * as viewUtils from '../../utils/view-utils';
import {getErrorDescription} from '../../utils/view-utils';
import SiteSocket from './../../socket/SiteSocket';
import * as blockUtils from '../../utils/BlockUtils';

class SitesListContainer extends Component {
  constructor(props) {
    super(props);

    this.getSites = this.getSites.bind(this);

    this.state = {
      sites: [],
      totalElements: 0,
      totalPages: 0,
      tableId: 'site-table',
      getSitesError: null,
    };

    this.pageNumber = 0;
    this.elementsCount = 10;
    this.sortingName = 'id';
    this.sortingType = 'ASC';
    this.searchPhrase = '';
  }

  componentDidMount() {
    SiteSocket.getInstance().connect();
    this.getSites();
  }

  componentWillUnmount() {
    SiteSocket.getInstance().disconnect();
  }

  getSites(
      pageNumber = this.pageNumber,
      elementsCount = this.elementsCount,
      sortingName = this.sortingName,
      sortingType = this.sortingType,
      searchPhrase = this.searchPhrase,
  ) {
    const data = {
      page: pageNumber,
      size: elementsCount,
      query: searchPhrase,
      sort: `${sortingName},${sortingType.toLowerCase()}`,
    };

    blockUtils.blockUI();
    sitesApi.getSites(data).then((response) => {
      blockUtils.unblockUI();
      if (response.status !== 200) {
        this.setState({
          sites: [],
          getSitesError: response.statusText,
        });

        return;
      }

      const sites = response.data.content;

      this.setState({
        sites: sites,
        totalElements: response.data.totalElements,
        totalPages: response.data.totalPages,
      });
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  render() {
    return (
      <WhitePortlet caption={i18next.t('sites.name', {count: 2})} icon="icon-home">
        <ErrorBox errorMessage={getErrorDescription(this.state.getSitesError)}/>
        <ErrorBox errorMessage={getErrorDescription(this.props.destroySiteError)}/>

        <SitesList
          getData={this.getSites}
          tableId={this.state.tableId}
          sites={this.state.sites}
          totalPages={this.state.totalPages}
          totalElements={this.state.totalElements}
          createSiteError={this.props.createSiteError}
          user={this.props.user}
        />
      </WhitePortlet>
    );
  }
}

SitesListContainer.propTypes = {
  createSiteError: PropTypes.object,
  destroySiteError: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = function(store) {
  return {
    createSiteError: store.sitesState.createSiteError,
    destroySiteError: store.sitesState.destroySiteError,
    user: store.usersState.userProfile,
  };
};

export default connect(mapStateToProps)(SitesListContainer);
